// src/routes.js
import i18next from './i18n';

// Helper function to get route translations with fallback
const getRouteValue = (ns, key, fallback) => {
    const languages = ['en', 'ru', 'hy'];
    const translations = {};

    languages.forEach(lng => {
        // Try to get from i18next first (S3)
        const resource = i18next.getResourceBundle(lng, ns);
        if (resource && resource[key]) {
            translations[lng] = resource[key];
        } else {
            // Fallback to the original local value
            translations[lng] = fallback[lng];
        }
    });

    return translations;
};

// Initialize with fallback values first, then update when i18next loads
export let routes = {
    about: {
        en: "about-us", // Fallback values
        ru: "o-nas",
        hy: "մեր-մասին",
    },
    contacts: {
        en: "contacts",
        ru: "contacts",
        hy: "contacts",
    },
    blog: {
        en: "blog",
        ru: "blog",
        hy: "blog",
    },
    consultation: {
        en: "free-consultation",
        ru: "besplatnaya-konsultaciya",
        hy: "ankax-khosq",
    },
    review: {
        en: "review",
        ru: "review",
        hy: "review",
    },
    legalservice: {
        en: "legal-service",
        ru: "legal-service",
        hy: "legal-service",
    },
    ourspace: {
        en: "our-space",
        ru: "our-space",
        hy: "our-space",
    },
    faq: {
        en: "faq",
        ru: "faq",
        hy: "faq",
    },
    chooseUs: {
        en: "why-choose-us",
        ru: "why-choose-us",
        hy: "why-choose-us",
    },
    salesprocces: {
        en: "sales-process",
        ru: "sales-process",
        hy: "sales-process",
    },
    sales: {
        en: "sales",
        ru: "sales",
        hy: "sales",
    },
    rent: {
        en: "rent",
        ru: "rent",
        hy: "rent",
    },
    business: {
        en: "business",
        ru: "business",
        hy: "business",
    },
    exclusive: {
        en: "exclusive",
        ru: "exclusive",
        hy: "exclusive",
    },
    search: {
        en: "search",
        ru: "search",
        hy: "search",
    },
    favorites: {
        en: "favorites",
        ru: "favorites",
        hy: "favorites",
    },
    estateDetails: {
        en: "estate-details",
        ru: "estate-details",
        hy: "estate-details",
    },
};

// Update routes when i18next is ready and has loaded translations
const updateRoutesFromS3 = () => {
    console.log('Updating routes from S3 translations...');

    routes = {
        about: getRouteValue('about', 'aboutUs-url', routes.about),
        contacts: routes.contacts, // Keep static
        blog: getRouteValue('blog', 'blog-url', routes.blog),
        consultation: getRouteValue('freeconsult', 'freeCons', routes.consultation),
        review: getRouteValue('rev', 'rev', routes.review),
        legalservice: getRouteValue('legal', 'legalservice', routes.legalservice),
        ourspace: getRouteValue('ourspace', 'ourspace-url', routes.ourspace),
        faq: getRouteValue('faq', 'faq-url', routes.faq),
        chooseUs: getRouteValue('choose', 'whyChooseUs', routes.chooseUs),
        salesprocces: getRouteValue('seales', 'sealesProces', routes.salesprocces),
        sales: getRouteValue('estate', 'sales-url', routes.sales),
        rent: getRouteValue('estate', 'rent-url', routes.rent),
        business: getRouteValue('estate', 'business-url', routes.business),
        exclusive: getRouteValue('estate', 'exclusive-url', routes.exclusive),
        search: getRouteValue('estate', 'search-url', routes.search),
        favorites: getRouteValue('estate', 'favorites-url', routes.favorites),
        estateDetails: getRouteValue('estate', 'details-url', routes.estateDetails),
    };

    console.log('Routes updated from S3:', routes);
};

// Set up event listeners to update routes when translations load
if (i18next.isInitialized) {
    updateRoutesFromS3();
} else {
    i18next.on('initialized', updateRoutesFromS3);
}

i18next.on('loaded', updateRoutesFromS3);
i18next.on('languageChanged', updateRoutesFromS3);

// Export a function to check if routes are ready
export const routesReady = new Promise((resolve) => {
    if (i18next.isInitialized) {
        resolve(routes);
    } else {
        i18next.on('initialized', () => resolve(routes));
    }
});